(function () {
  'use strict';

  angular
  .module('videoPlayer', ['ui.router']);
}());
